<template>
  <div class="has-text-centered">
    <span v-for="(data, key) in questionsId" :key="key">
      <span style="cursor:pointer" @click="toSlide(key)">
        <b-icon :pack="packIcon(key)" icon="circle" class="dot"></b-icon>
      </span>
    </span>
    <!-- BOUTONS PLAY/STOP SLIDER-->
    <span v-if="this.sliderOn" @click="stop()">
      <img
        style="margin-bottom:-5px; width:20px"
        src="@/assets/img/icons/pause.png"
        alt="pause-icon"
      />
    </span>

    <span v-else @click="autoplay()">
      <img
        style="margin-bottom:-5px; width:20px"
        src="@/assets/img/icons/play.png"
        alt="play-icon"
      />
    </span>
  </div>
</template>

<script>
export default {
  name: 'CarouselButtons',
  data () {
    return {
      currentSlide: 0,
      timer: null,
      sliderOn: true
    }
  },
  props: ['questionsId'],
  created () {
    this.$store.commit('CURRENT_SLIDE', 0)
    this.currentSlide = 0
    this.timer = null
    this.sliderOn = true
    this.autoplay()
  },
  beforeDestroy () {
    this.$store.commit('CURRENT_SLIDE', 0)
    clearInterval(this.timer)
  },
  methods: {
    toSlide (index) {
      this.stop()
      this.currentSlide = index
      this.$store.commit('CURRENT_SLIDE', this.currentSlide)
    },
    stop () {
      this.sliderOn = false
      clearInterval(this.timer)
    },
    autoplay () {
      this.sliderOn = true
      this.timer = setInterval(() => {
        var SlideSuivante = this.currentSlide + 1
        if (SlideSuivante >= this.questionsId.length) {
          this.currentSlide = 0
        } else {
          this.currentSlide = this.currentSlide + 1
        }
        this.$store.commit('CURRENT_SLIDE', this.currentSlide)
      }, 10000)
    },
    packIcon (index) {
      if (this.currentSlide === index) return 'fas'
      else return 'far'
    }
  }
}
</script>

<style scoped>
.dot {
  margin: 10px 2px 0px 0;
  font-size: 8px;
}
.middleDot {
  vertical-align: sub;
}
</style>



// WEBPACK FOOTER //
// src/components/resultats/components/CarouselButtons.vue